import React from 'react'
import PropTypes from 'prop-types'
import constants from 'lib/constants'
import CellsPerPositionGraph from './CellsPerPositionGraphContainer'
import _ from 'lodash'

class GraphView extends React.Component {
  static propTypes = {
    qcResults: PropTypes.shape({
      low_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      normal_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      high_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      }))
    }),
  }

  static defaultProps = {
    qcResults: {
      low_jobs: [],
      normal_jobs: [],
      high_jobs: [],
      flow_times: {}
    }
  }

  render () {
    const { qcResults } = this.props
    return (
      <div style={{ paddingTop: 20 }}>
        <table className='table table-bordered'>
          <tbody>
            {
              _.map(constants.QC_LEVELS, (level) => (
                <tr key={level}>
                  {
                    _.map(qcResults[`${level}_jobs`], (job) => {
                      return (
                        <td key={job.job_id}>
                          Job: {job.job_id}
                          <CellsPerPositionGraph job={job} />
                        </td>
                      )
                    })
                  }
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    )
  }
}

export default GraphView



// WEBPACK FOOTER //
// ./src/routes/QC/components/GraphView.jsx